export default function getNoun (
  number: number,
  singular: string,
  few: string,
  many: string,
): string {
  const mod10 = number % 10
  const mod100 = number % 100

  if (mod10 === 1 && mod100 !== 11) {
    return singular
  }
  else if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) {
    return few
  }
  else {
    return many
  }
}
